import { useLayoutEffect, type RefObject } from 'react';

/**
 * Keeps an element's --space-below at the page space beneath it, which a
 * viewport-tall layout leaves room for so its foot meets the viewport's once the
 * page is scrolled to the end.
 * @param {RefObject<HTMLElement>} ref The element.
 */
export function useSpaceBelow(ref: RefObject<HTMLElement>) {
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    /** Writes the page space below the element to its --space-below. */
    const measure = () => {
      const below =
        document.documentElement.scrollHeight -
        (element.getBoundingClientRect().bottom + window.scrollY);
      element.style.setProperty(
        '--space-below',
        `${Math.max(0, Math.round(below))}px`
      );
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(document.body);
    return () => observer.disconnect();
  }, [ref]);
}
